export default __webpack_public_path__ + "static/media/fruitjelly.e2ce1667.jpg";